import axios from "axios";
import Cookies from "js-cookie";

const apiGuard = axios.create({
  baseURL: process.env.REACT_APP_API_URL_CMS,
  timeout: 10000,
});

apiGuard.interceptors.request.use(
  (config) => {
    // xkey
    const xkey = process.env.REACT_APP_CMS_XKEY;
    if (xkey) {
      config.headers = config.headers ?? /* istanbul ignore next */ {};
      config.headers["x-api-key"] = xkey; 
    }

    // OPTIONAL: Bearer token (if you also use auth)
    const token = Cookies.get("access_token");
    if (token) {
      config.headers = config.headers ?? /* istanbul ignore next */ {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error) //NOSONAR
);

export default apiGuard;